import { AppRoutes } from "../../constants";
import type { IProtectedRouteProps } from "../../types";
import { Navigate } from "react-router-dom";

export default function _ProtectedRoute(props: IProtectedRouteProps) {
  if (!props.isLoggedIn) return <Navigate to={AppRoutes.adminLogin} replace />;

  return props.children;
}
